import { Component, Input } from '@angular/core';
import { Lesson } from '@mira-avant/mtlibs';
import { AngularModule } from '../../../../modules/angular.module';

@Component({
	selector: 'app-lesson-tile',
	standalone: true,
	imports: [AngularModule],
	templateUrl: './lesson-tile.component.html',
	styleUrl: './lesson-tile.component.scss',
})
export class LessonTileComponent {
	@Input('lesson') public lesson: Lesson | undefined;
}
